<template>
  <div class="dhr-production">
    <h2 class="subtitle">What do you want to start?</h2>
    <h3 class="shadows">Choose the type of product you want to manufacture?</h3>
    <div class="dhr-production-types">
      <div class="box" @click="selectProduction('Assembly')">
        <div class="img-box">
          <img src="@/assets/images/dhr-steps/assembly@2x.png" />
        </div>
        <p>Assembly</p>
      </div>
      <div class="box" @click="selectProduction('Subpart')">
        <div class="img-box">
          <img src="@/assets/images/dhr-steps/subpart@2x.png" />
        </div>
        <p>Subpart</p>
      </div>
      <div class="box" @click="selectProduction('Single')">
        <div class="img-box">
          <img src="@/assets/images/dhr-steps/single@2x.png" />
        </div>
        <p>Single</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      selectedProduction: ''
    };
  },
  mounted() {},
  methods: {
    selectProduction(val){
      this.selectedProduction = val
      this.$emit('productionTypeSelected', this.selectedProduction)
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/dhrChoiceProduction.scss";

</style>;
